// extracted by mini-css-extract-plugin
export var fullWidthButton = "_db-0";